<div class="variable-select-container">
  <mat-icon
    aria-hidden="false"
    class="rds-c-selection-info-icon"
    [mtnaPopover]="config"
    [mtnaClosePopoverAriaLabel]="selectLabel | rdsPopoverAriaLabel: false"
    [mtnaOpenPopoverAriaLabel]="selectLabel | rdsPopoverAriaLabel: true"
    >info
  </mat-icon>
  <mat-form-field appearance="outline" floatLabel="always">
    <mat-label>{{ selectLabel }}</mat-label>
    <mat-select
      [compareWith]="_compareVariable"
      [disabled]="disabled"
      [errorStateMatcher]="$any(_matcher)"
      [multiple]="multiSelect"
      [required]="required"
      [placeholder]="selectPlaceholder"
      [value]="value"
      (openedChange)="handleOpenedChange($event)"
      panelClass="rds-c-dimension-virtual-scroll-panel"
    >
      <mat-select-trigger>
        <span *ngIf="!!value && value.length > 0 && !!value[0]">
          {{ value[0].label }}
        </span>
        <span *ngIf="(value?.length || 0) > 1" class="rds-c-additional-selection">
          (+{{ $any(value?.length) - 1 }} {{ value?.length === 2 ? 'other' : 'others' }})
        </span>
      </mat-select-trigger>
      <mtna-select-search [noResultsFound]="_noSearchResults" (search)="filterVariables($event)"></mtna-select-search>
      <cdk-virtual-scroll-viewport [class.no-results]="_noSearchResults" itemSize="48" [maxBufferPx]="48 * 12" [minBufferPx]="48 * 7">
        <mat-option
          *cdkVirtualFor="let variable of _filteredVariables$ | async; trackBy: _trackByVariable"
          (onSelectionChange)="_handleOptionSelectionChange($event)"
          [disabled]="disabledOptions?.length | rdsCoreResourceExists: variable.uri || variable.id:disabledOptions"
          [value]="variable"
        >
          <span
            ><strong>{{ variable.id }}</strong></span
          >
          <span *ngIf="variable.label"> - {{ variable.label }}</span>
        </mat-option>
      </cdk-virtual-scroll-viewport>
    </mat-select>
    <mat-error align="end">
      <span *ngFor="let error of $any(_control?.errors) | keyvalue" [ngSwitch]="error.key">
        <ng-template ngSwitchCase="required" i18n>This field is <strong>required</strong></ng-template>
        <ng-template ngSwitchDefault>{{ error.value }}</ng-template>
      </span>
    </mat-error>
    <mat-hint *ngIf="(maxSelection || 0) > 1" align="end" i18n="As in Make up to 4 selections|"
      >Make up to {{ maxSelection }} selections
    </mat-hint>
    <mat-icon *ngIf="suffixIcon" matSuffix>{{ suffixIcon }}</mat-icon>

    <rds-c-chips
      *ngIf="value?.length"
      [ariaLabel]="chipsAriaLabel"
      [chips]="value | rdsVariablesToChips"
      [disabled]="disabled"
      [orderable]="orderable"
      [selectable]="false"
      [vertical]="true"
      (removed)="_removeVariable($event.id)"
      (reordered)="_reorderVariables($event)"
    ></rds-c-chips>
  </mat-form-field>
</div>
